import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './section-label.module.scss';

interface SectionLabelProps {
  children: ReactNode;
  className?: string;
}

export default function SectionLabel({ children, className }: SectionLabelProps) {
  return <div className={clsx(styles.label, className)}>{children}</div>;
}
